import { useLocation } from 'wouter'
import { useEffect, useRef } from 'react'

const getPreferredScrollBehavior = (): ScrollBehavior => {
  const prefersReducedMotion =
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches

  return prefersReducedMotion ? 'auto' : 'smooth'
}

const scrollToCurrentHash = (behavior: ScrollBehavior) => {
  if (typeof window === 'undefined') {
    return false
  }

  const hash = window.location.hash.slice(1)
  if (!hash) {
    return false
  }

  const element = document.getElementById(hash)
  if (!element) {
    return false
  }

  element.scrollIntoView({ behavior })
  return true
}

function ScrollToTop(): null {
  const [location] = useLocation()
  const oldLocationRef = useRef(location || '')

  useEffect(() => {
    const behavior = getPreferredScrollBehavior()

    if (oldLocationRef.current !== location) {
      if (scrollToCurrentHash(behavior)) {
        oldLocationRef.current = location
        return
      }

      window.scrollTo({
        top: 0,
        left: 0,
        behavior,
      })
    } else if (scrollToCurrentHash('auto')) {
      oldLocationRef.current = location
      return
    }

    oldLocationRef.current = location
  }, [location])

  return null
}

export { ScrollToTop }
